<script lang="ts">
	let className = '';
	export { className as class };

	export let shapeClass = '';
</script>

<div class={className}>
	<div class="stage-shape-container {shapeClass}">
		<slot />
	</div>
</div>

<style lang="postcss">
	:root {
		/* background svgs width="951" height="512" */
		/* aspect ratio -> 1,857421875  */
		--stage-shape-imgage-aspect-ratio: 1.857421875;
		--stage-shape-max-width: 48rem;
	}

	.stage-shape-container {
		color: white;
		width: 100%;
		max-width: var(--stage-shape-max-width);
		padding: 0.75rem;
		padding-top: 6.25rem;
		background-image: url('/images/stage_shape.svg');
		height: calc(48rem / var(--stage-shape-imgage-aspect-ratio));
		background-repeat: no-repeat;
		background-size: 48rem;
		background-position-y: top;
		background-position-x: 30%;
	}

	@media (min-width: 786px) {
		.stage-shape-container {
			padding-left: 1rem;
			padding-right: 1rem;
			padding-top: 5.375rem;
			/* background-size: contain;

			height: calc(
				min(100vw, var(--stage-shape-max-width)) / var(--stage-shape-imgage-aspect-ratio)
			); */
		}
	}

	@media (min-width: 1024px) {
		.stage-shape-container {
			height: calc(
				min(100vw, var(--stage-shape-max-width)) / var(--stage-shape-imgage-aspect-ratio)
			);
		}
	}

	@media (min-width: 1366px) {
		.stage-shape-container {
			padding-left: 2.5rem;
		}
	}
</style>
